import { sanitizeEmailHTML } from '../../services/sanitizeHTML';
import {
  CUSTOM_MESSAGE_ELEMENT_ID,
  CUSTOM_MESSAGE_TEMPLATE_PLACEHOLDER,
  EMPTY_MESSAGE_PLACEHOLDER,
} from './emailPreviewIframeConstants';

export function hasRealHtmlContent(html: string | undefined): boolean {
  if (!html) {
    return false;
  }
  const trimmed = html.trim();
  return trimmed !== '' && trimmed !== '<p><br></p>' && trimmed !== '<p></p>';
}

export function isEditablePlaceholderContent(html: string): boolean {
  const trimmed = html.trim();
  return trimmed === EMPTY_MESSAGE_PLACEHOLDER || trimmed === '<p><br></p>' || trimmed === '';
}

export function getEditableDisplayHtml(html: string): string {
  return hasRealHtmlContent(html) ? html : EMPTY_MESSAGE_PLACEHOLDER;
}

export function extractStyleContentFromHead(fullHtml: string): string {
  const headMatch = fullHtml.match(/<head[^>]*>([\s\S]*)<\/head>/i);
  if (!headMatch) {
    return '';
  }

  const styleMatch = headMatch[1].match(/<style[^>]*>([\s\S]*?)<\/style>/gi);
  if (!styleMatch) {
    return '';
  }

  return styleMatch.map((styleTag) => styleTag.replace(/<\/?style[^>]*>/gi, '')).join('\n');
}

export function buildCustomMessageDiv(initialCustomHtml: string): string {
  const hasContent = hasRealHtmlContent(initialCustomHtml);
  return `<div id="${CUSTOM_MESSAGE_ELEMENT_ID}" data-custom-message-placeholder contenteditable="true" style="cursor: pointer; min-height: 20px; position: relative;">
      ${hasContent ? initialCustomHtml : ''}
    </div>`;
}

export function buildEmailPreviewContainerStyles(styleContent: string): string {
  return `
        <style>
          /* Prevent fixed positioning from escaping container - convert to absolute */
          [style*="position: fixed"], [style*="position:fixed"] {
            position: absolute !important;
          }
          /* Ensure container properly contains content */
          body, html {
            position: relative;
            overflow: visible;
          }
          ${styleContent || ''}
        </style>`;
}

export function buildEmailPreviewHtml(
  templateHtml: string,
  initialCustomHtml: string,
): string | null {
  if (!templateHtml) {
    return null;
  }

  const customMessageDiv = buildCustomMessageDiv(initialCustomHtml);
  const fullHtml = templateHtml.replace(
    new RegExp(CUSTOM_MESSAGE_TEMPLATE_PLACEHOLDER, 'g'),
    customMessageDiv,
  );

  const styleContent = extractStyleContentFromHead(fullHtml);

  let bodyContent = fullHtml;
  const bodyMatch = fullHtml.match(/<body[^>]*>([\s\S]*)<\/body>/i);
  if (bodyMatch) {
    bodyContent = bodyMatch[1];
  }

  const sanitizedBody = sanitizeEmailHTML(bodyContent, {
    allowAnchors: true,
  });

  const containerStyles = buildEmailPreviewContainerStyles(styleContent);
  return `${containerStyles}${sanitizedBody}`;
}

export function computeCustomMessagePosition(element: HTMLElement): { top: number; left: number } {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top + rect.height / 2,
    left: rect.right + 15,
  };
}
